<template>
  <div class="container">
    <div class="content">
      <h2>🏡 Home Is Where the Heart (and Wallet) Is: Your Living Situation 🏡</h2>
      <p>Ah, home sweet home! Where you kick back, relax, and maybe share a space with some two-legged or four-legged roomies. But let's get real; your living situation is more than just a roof over your head—it's a big piece of your financial puzzle. So, where do you hang your hat (and your scratching post)?</p>

      <div class="option" @click="selectOption('own-home')" :class="{ selected: isSelected('own-home') }">
        <span class="icon">🏡</span>
        <b>You own your home, condo, or co-op.</b>
       <br> Smart Money Says: This is the equivalent of marking your territory in the feline world. You've claimed your space, and it's all yours.
            Why It Matters: Homeownership is a long-term commitment that can build substantial equity. But it also comes with responsibilities like maintenance, taxes, and being the go-to host for family gatherings (you've been warned).
      </div>

      <div class="option" @click="selectOption('rent-alone')" :class="{ selected: isSelected('rent-alone') }">
        <span class="icon">🏢</span>
        <b>You're renting your own place.</b>  <br>Smart Money Says: This is like a cat who's found a sunny window sill to claim. It's yours, but only for now.
            Why It Matters: Renting offers flexibility but comes with monthly payments that don't build equity. Make sure you're balancing this expense with your other financial goals.
      </div>

      <div class="option" @click="selectOption('live-with-parents')" :class="{ selected: isSelected('live-with-parents') }">
        <span class="icon">😸</span>
        <b>You're living with family</b><br>
        Smart Money Says: it's a great way to save money and if you are really lucky still get your momma cat to do your laundry.  Be careful not to get too comfortable and not learn how to adult and blow all your money on catnip.
        Why it Matters: these days the cost of living is so high that it takes longer to get out there on your own. Just be smart about saving up so that you can eventually leave the cat tree. Remember your parents are getting older too. 
      </div>

      <div class="option" @click="selectOption('live-with-roommates')" :class="{ selected: isSelected('live-with-roommates') }">
        <span class="icon">🙀</span>
        <b>You're living with roommates and likely saving on costs.</b><br>
        Smart Money Says: This is like a group of alley cats sharing a warm spot on a chilly night. It's communal, cozy, and cost-effective.
            Why It Matters: Hey, there's no shame in this game! It's a strategic move to save money, pay off debt, or plan for future leaps. Plus, it can be a blast (most of the time).
      </div>

    
    </div>
  </div><br><br><br><br><br><br>
</template>


<script>
import { onboardingStore } from '@/components/stores/onboardingStore'; // Adjust the path as necessary

export default {
  setup() {
    const store = onboardingStore();

    const selectOption = (option) => {
      // Set the selected option directly
      store.updateFormData({ housing_status: option });
    };

    // Helper method to check if an option is selected
    const isSelected = (option) => store.formData.housing_status === option;

    return { store, selectOption, isSelected };
  },
};
</script>





<style scoped>
.container {
  background-color: #4A148C; 
 color: black;
 padding: 20px;
 border-radius: 20px;
 display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 300px;
  max-width: 800px; /* Set a maximum width */
  align-items: center; /* Centered alignment */
  margin: auto; /* Center the container on the page */
  margin-top: 0; /* Adjusted as per your requirement */
}

.content {
background-color: white;
padding: 20px;
border-radius: 10px;
color: black;
}

.option {
padding: 10px;
border: 1px solid #ccc;
border-radius: 10px;
text-align: center;
box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
cursor: pointer;
transition: transform 0.3s ease, box-shadow 0.3s ease;
margin-bottom: 10px;
}

.option:hover {
transform: translateY(-5px);
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}


.selected {
background-color: #4A148C; /* More solid color for selection */
color: white;
}


.icon {
font-size: 24px; /* Larger icon size */
}

/* Additional style if needed */
</style>